var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSysEmpty = function SvgSysEmpty(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7 56a3 3 0 0 1-3-3V31.115a.896.896 0 0 1 0-.181c.017-.265.138-.513.337-.688L17.23 10.52a6.063 6.063 0 0 1 4.956-2.522h19.623a6.065 6.065 0 0 1 4.956 2.522l12.892 19.726a1.002 1.002 0 0 1 .34.735.92.92 0 0 1 0 .1V53a3 3 0 0 1-3 3H7Zm-1-3a1 1 0 0 0 1 1h50a1 1 0 0 0 1-1V32h-7a1 1 0 0 0-1 1v4a5 5 0 0 1-5 5H19a5 5 0 0 1-5-5v-4a1 1 0 0 0-1-1H6v21Zm7-23a3 3 0 0 1 3 3v4a2.989 2.989 0 0 0 .877 2.123A2.993 2.993 0 0 0 19 40h26a2.991 2.991 0 0 0 3-3v-4a3 3 0 0 1 3-3h5.994L45.15 11.65l-.017-.025-.016-.021a4.038 4.038 0 0 0-3.3-1.68H22.193a4.037 4.037 0 0 0-3.3 1.68l-.017.021-.016.025L7.015 30H13Z"
  })));
};
export default SvgSysEmpty;